"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TodoHelpers = void 0;
class TodoHelpers {
    static calculateTodoProgress(activeTodo) {
        if (!activeTodo) {
            console.log('[TodoHelpers] no activeTodo, progress 0');
            return 0;
        }
        if (activeTodo.items && activeTodo.items.length > 0) {
            const completedItems = activeTodo.items.filter(item => item.done).length;
            const percentage = Math.round((completedItems / activeTodo.items.length) * 100);
            console.log('[TodoHelpers] todo items:', activeTodo.items.map(i => ({ id: i.id, title: i.title, done: i.done })));
            console.log('[TodoHelpers] completedItems:', completedItems, 'total:', activeTodo.items.length, 'percentage:', percentage);
            return percentage;
        }
        console.log('[TodoHelpers] todo has no items, done:', activeTodo.done);
        return activeTodo.done ? 100 : 0;
    }
    static completedTodosCount(activeTodo) {
        if (!activeTodo) {
            return 0;
        }
        if (activeTodo.items && activeTodo.items.length > 0) {
            return activeTodo.items.filter(item => item.done).length;
        }
        return activeTodo.done ? 1 : 0;
    }
    static totalTodosCount(activeTodo) {
        if (!activeTodo) {
            return 0;
        }
        if (activeTodo.items && activeTodo.items.length > 0) {
            return activeTodo.items.length;
        }
        return 1;
    }
}
exports.TodoHelpers = TodoHelpers;
